import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { FormFieldUpdateEvent } from '../../layouts/chatbot/chatbot.models';

@Injectable({ providedIn: 'root' })
export class ChatbotBridgeService {
  private formUpdateSubject = new Subject<FormFieldUpdateEvent>();
  readonly formUpdate$: Observable<FormFieldUpdateEvent> = this.formUpdateSubject.asObservable();

  private chatbotInstance: any = null;

  registerChatbot(instance: any): void {
    this.chatbotInstance = instance;
  }

  publishFormUpdate(event: FormFieldUpdateEvent): void {
    this.formUpdateSubject.next(event);
  }

  receiveDataFromParent(dataType: string, data: any[]): void {
    this.chatbotInstance?.receiveDataFromParent(dataType, data);
  }

  showSubmissionSuccess(complaintNo?: string): void {
    this.chatbotInstance?.showSubmissionSuccess(complaintNo);
  }

  showSubmissionError(error?: string): void {
    this.chatbotInstance?.showSubmissionError(error);
  }

  syncDocument(doc: any): void {
    if (this.chatbotInstance?.documentList) {
      this.chatbotInstance.documentList.push(doc);
    }
  }

  unsyncDocument(index: number): void {
    if (this.chatbotInstance?.documentList) {
      this.chatbotInstance.documentList.splice(index, 1);
    }
  }
}
